const validateEmail = (email = '') => {
    const regExp = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    return !!regExp.test(email);
};
const validateNotEmpty = (value) => {
    if (!value && value !== 0) {
        return false;
    }
    if (Array.isArray(value) && !value.length) {
        return false;
    }
    if (typeof value === 'object' && !!Object.keys(value).length) {
        return false;
    }
    return true;
};
const validateNumber = (value = '') => {
    const regExp = /^[0-9]+$/;
    return !!regExp.test(value.toString());
};
const validateCreditCard = (value = '') => {
    const regExp = /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;
    return !!regExp.test(value.toString());
};
const validateMaxLen = (value = '', maxLen) => {
    if (!maxLen) {
        return true;
    }
    return value.toString().length <= maxLen;
};
const validateMinLen = (value = '', minLen) => {
    if (!minLen) {
        return true;
    }
    return value.toString().length >= minLen;
};

export { validateCreditCard, validateEmail, validateMaxLen, validateMinLen, validateNotEmpty, validateNumber };
//# sourceMappingURL=validators.js.map
